import { Divider, Grid2, Show, SimpleLoader, Tab, Tabs } from "components";
import { useFetchQuery } from "hooks/useQueries";
import { FeePlanListInterface } from "interfaces/PrivateRouteInterface";
import { useState } from "react";
import SubscriptionFlow from "./SubscriptionFlow";

const OnBoardingFlowTab = () => {
  const [tab, setTab] = useState(0);

  const [customAgreementTemplate, setCustomAgreementTemplate] = useState([]);
  const [feePlanList, setFeePlanList] = useState([]);

  const { isFetching: agreementFetching } = useFetchQuery({
    key: ["ON_BOARDING_FLOW"],
    route: "/custom-agreement/",
    success: (response: any) => {
      setCustomAgreementTemplate(
        response?.data?.data.map((dataItem: { title: string; id: number }) => {
          return {
            name: dataItem.title,
            value: dataItem.id,
          };
        }),
      );
    },
  });

  const { isFetching: feePlanFetching } = useFetchQuery({
    key: ["GET_FEE_PLANS_DROPDOWN"],
    route: "/api/revenue/fee-plan/dropdown/",
    requestBody: {
      is_advanced: true,
    },
    success: (data: any) => {
      setFeePlanList(
        data?.data?.data.map((dataItem: FeePlanListInterface) => {
          return {
            name: dataItem.name,
            value: dataItem.value,
          };
        }),
      );
    },
  });

  const { data: estampTags } = useFetchQuery({
    key: ["ESTAMP_TAGS_QUERY_KEY"],
    route: "/estamp-tags/",
  });

  if (agreementFetching && feePlanFetching) return <SimpleLoader />;

  const tabs = [
    {
      label: "Advisor initiated Advisory Flow",
      component: (
        <SubscriptionFlow
          type="advisor_initiated_advisory_flow"
          customAgreementTemplate={customAgreementTemplate}
          feePlanData={feePlanList}
          estampTags={estampTags?.data?.data}
        />
      ),
    },
    {
      label: "Client initiated Advisory Flow",
      component: (
        <SubscriptionFlow
          type="client_initiated_advisory_flow"
          customAgreementTemplate={customAgreementTemplate}
          feePlanData={feePlanList}
          estampTags={estampTags?.data?.data}
        />
      ),
    },
  ];

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12} display={"flex"} flexDirection={"column"}>
        <Tabs
          sx={{
            "& .MuiTabs-flexContainer": {
              backgroundColor: "var(--white)",
            },
          }}
          onChange={(e, val) => setTab(val)}
          value={tab}
        >
          {tabs.map((tab, index) => (
            <Tab key={index} label={tab.label} disableRipple />
          ))}
        </Tabs>
        <Divider />
      </Grid2>
      <Grid2 size={12} mt={1}>
        {tabs.map((tabItem, index) => (
          <Show.When key={index} isTrue={tab === index}>
            {tabItem.component}
          </Show.When>
        ))}
      </Grid2>
    </Grid2>
  );
};

export default OnBoardingFlowTab;
